import React, { useCallback, useMemo } from 'react';
import PageLayout from '../../components/PageLayout';
import { useOrganizerContext } from '../../../common/Context';
import GonorarBlock from '../../components/GonorarBlock';

export default function OrganizerComissionGonorar(props) {
    const [org, setOrg] = useOrganizerContext();
    const x = useMemo(()=>({organizatorMeropriyatiyaID: org?.ID}),[org])
    // const organizator = useSelector(getOrganizatorFromRoles(["ОрганизаторФедерации", "АдминистраторОрганизатораФедерации"], true)); // Организатор
    // const auth = useAuth()
    return (
        <PageLayout>
            <div style={{ padding: "10px" }}>
            <GonorarBlock {...props} source={"/api/shablonisudeiskikhgonorarov/list/org"}
                sourceKey="org"
                create={true}
                ctx={x}
            />
            </div>
        </PageLayout>
    );
}
